module.exports = __webpack_public_path__ + "static/media/Satish_Vithalani.bbbd4749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Satish_Vithalani.jpg
// module id = 1128
// module chunks = 0